<div class="fixed" *ngIf="expand" tabindex="0" (click)="OnCloseDropdown()" (keydown.esc)="OnCloseDropdown()"></div>
<div class="upp-dropdown__anchor">
    <div class="dropdown" [ngClass]="{ 'visible': expand, 'clear': fill === 'clear' }" role="menu">
        <ng-content select="upp-dropdown-title"></ng-content>
        <div *ngIf="!HasTitle && fill !== 'clear'" style="clear:both; height:20px"></div>
        <ion-list>
            <ng-content select="upp-dropdown-content, upp-dropdown-separate"></ng-content>
        </ion-list>
        <div style="clear:both; height:20px"></div>
    </div>
</div>